export const routes = {
  general: {
    root: {
      title: "General Root",
      path: () => "/",
    },
  },
  canvas: {
    overview: {
      title: (title: string) => title,
      path: (id: string, isParticipation?: boolean) => `/${isParticipation ? "participation" : "canvas"}/${id}`,
    },
    actionPlan: {
      title: (title: string) => title,
      path: (id: string, isParticipation?: boolean) =>
        `/${isParticipation ? "participation" : "canvas"}/${id}/action-plan`,
    },
    insights: {
      title: (title: string) => title,
      path: (id: string, isParticipation?: boolean) =>
        `/${isParticipation ? "participation" : "canvas"}/${id}/insights`,
    },
    focusArea: {
      title: (title: string) => title,
      path: (id: string, groupIndex: number, areaIndex: number, isParticipation?: boolean) =>
        `/${isParticipation ? "participation" : "canvas"}/${id}/area/${groupIndex}/${areaIndex}`,
    },
  },
};
